var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex radio align-items-center",on:{"click":function($event){return _vm.select()}}},[_c('div',{staticClass:"flex-fill radio__label"},[_vm._t("default")],2),_vm._v(" "),_c('div',[_c('span',{staticClass:"radio__switch",class:[{ on: _vm.state }]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }